const STORAGE_KEY = "suitaAppVersaoAtual";
const RELOAD_GUARD_KEY = "suitaAppVersaoReloadGuard";
const MAX_AUTO_RELOAD_TENTATIVAS = 1;
const AUTO_RELOAD_JANELA_MS = 60000;

function normalizarVersao(versao) {
  return versao ? String(versao).trim() : "";
}

function notificarBloqueioAutoReload() {
  try {
    window.dispatchEvent(
      new CustomEvent("suita:versao-auto-reload-bloqueado", {
        detail: {
          maxTentativas: MAX_AUTO_RELOAD_TENTATIVAS,
          janelaMs: AUTO_RELOAD_JANELA_MS
        }
      })
    );
  } catch {}
}

function podeTentarAutoReload() {
  try {
    const agora = Date.now();
    const estadoCru = window.sessionStorage.getItem(RELOAD_GUARD_KEY);
    let estado = estadoCru ? JSON.parse(estadoCru) : null;

    if (!estado || !estado.primeiraTentativa || agora - estado.primeiraTentativa > AUTO_RELOAD_JANELA_MS) {
      estado = {
        primeiraTentativa: agora,
        tentativas: 0
      };
    }

    if (estado.tentativas >= MAX_AUTO_RELOAD_TENTATIVAS) {
      return false;
    }

    estado.tentativas += 1;
    estado.ultimaTentativa = agora;
    window.sessionStorage.setItem(RELOAD_GUARD_KEY, JSON.stringify(estado));
    return true;
  } catch {
    // Em caso de falha no sessionStorage, mantém o comportamento antigo.
    return true;
  }
}

export function obterVersaoAtual() {
  try {
    const armazenada = window.localStorage.getItem(STORAGE_KEY);
    return normalizarVersao(armazenada || process.env.VUE_APP_VERSAO);
  } catch {
    return normalizarVersao(process.env.VUE_APP_VERSAO);
  }
}

export function salvarVersaoAtual(versao) {
  const versaoNormalizada = normalizarVersao(versao || process.env.VUE_APP_VERSAO);
  try {
    window.localStorage.setItem(STORAGE_KEY, versaoNormalizada);
  } catch {}
  return versaoNormalizada;
}

export function aplicarVersaoNaUrl(url, versao = obterVersaoAtual()) {
  if (!url) return url;

  try {
    const urlBase = new URL(url, window.location.origin);
    if (urlBase.origin !== window.location.origin) {
      return url;
    }

    urlBase.searchParams.set("v", salvarVersaoAtual(versao));
    return urlBase.pathname + urlBase.search + urlBase.hash;
  } catch {
    return url;
  }
}

export function forcarAtualizacaoComVersao(versao) {
  if (!podeTentarAutoReload()) {
    // eslint-disable-next-line no-console
    console.error("Auto-reload por versão inválida interrompido para evitar loop infinito.");
    notificarBloqueioAutoReload();
    return false;
  }

  const versaoAtual = salvarVersaoAtual(versao);
  window.location.replace(aplicarVersaoNaUrl(window.location.href, versaoAtual));
  return true;
}

export function forcarRecarregamentoFresco(destino = window.location.href) {
  if (!podeTentarAutoReload()) {
    // eslint-disable-next-line no-console
    console.error("Auto-reload por versão inválida interrompido para evitar loop infinito.");
    notificarBloqueioAutoReload();
    return false;
  }

  try {
    const url = new URL(destino, window.location.origin);
    url.searchParams.set("reload", String(Date.now()));
    window.location.replace(url.toString());
    return true;
  } catch {
    window.location.replace(destino);
    return true;
  }
}

export function ehErroVersaoInvalida(error) {
  const data = error && error.response ? error.response.data : null;
  if (!data) return false;

  if (typeof data === "string") {
    return data.includes("Versão inválida");
  }

  if (Array.isArray(data)) {
    return data.some((item) => item && ((item.mensagem && item.mensagem.includes("Versão inválida")) || (item.error && item.error.includes("Versão inválida"))));
  }

  if (data.error && typeof data.error === "string") {
    return data.error.includes("Versão inválida");
  }

  if (data.erroMensagem && typeof data.erroMensagem === "string") {
    return data.erroMensagem.includes("Versão inválida");
  }

  if (data.mensagem && typeof data.mensagem === "string") {
    return data.mensagem.includes("Versão inválida");
  }

  return false;
}

export function obterVersaoServidor(error) {
  const data = error && error.response ? error.response.data : null;
  if (!data || typeof data !== "object") return "";

  if (data.versaoAtual) {
    return normalizarVersao(data.versaoAtual);
  }

  if (Array.isArray(data) && data.length > 0 && data[0] && data[0].versaoAtual) {
    return normalizarVersao(data[0].versaoAtual);
  }

  return "";
}
